import { apiClient } from './client'
import type { PageResponse, CefrLevel } from '@/types/common'
import type { CatalogCategory, CatalogUnit, LanguageUnitType } from '@/types/content'

export interface CatalogFilters {
  category?: string
  type?: LanguageUnitType
  cefr?: CefrLevel
  q?: string
  page?: number
  size?: number
}

export const catalogApi = {
  getCategories: () =>
    apiClient.get<CatalogCategory[]>('/catalog/categories'),

  getUnits: (filters: CatalogFilters = {}) => {
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== undefined && value !== '')
    )
    return apiClient.get<PageResponse<CatalogUnit>>('/catalog/units', { params })
  },
}
